import { render } from "./faultInfo.vue?vue&type=template&id=285bcff6"
import script from "./faultInfo.vue?vue&type=script&lang=js"
export * from "./faultInfo.vue?vue&type=script&lang=js"

import "./faultInfo.vue?vue&type=style&index=0&id=285bcff6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__